import { ConnectedPosition } from '@angular/cdk/overlay';

import { Observable } from 'rxjs';

import { EmojiVirtualScrollData, EmojiItem, EmojiListNavigationKeys } from '@recruitee/emoji';

import { EditorEvent, OverlayPosition } from '../../editor/types';

export interface EmojiOpenOptions {
  withSearch?: boolean;
  initialSearchValue?: string;
  preferredPositions?: ConnectedPosition[];
}

export abstract class EmojiPluginEvent extends EditorEvent {
  protected constructor(type: string) {
    super('EmojiPlugin', type);
  }
}

export class EmojiPluginPickerBeforeOpen extends EmojiPluginEvent {
  constructor() {
    super('pickerOpen');
  }
}

export class EmojiPluginPickerClose extends EmojiPluginEvent {
  constructor() {
    super('pickerClose');
  }
}

export type EmojiEditorPluginEvents = EmojiPluginPickerBeforeOpen | EmojiPluginPickerClose;

export interface EmojiListController {
  open: (
    position: OverlayPosition,
    options?: EmojiOpenOptions,
  ) => {
    select$: Observable<EmojiItem>;
    element: HTMLElement;
    backdropClick$: Observable<MouseEvent>;
  };
  setData: (data: EmojiVirtualScrollData) => void;
  close: () => void;
  updatePosition: (position: OverlayPosition) => void;
  isOpen: () => boolean;
  handleKey: (key: EmojiListNavigationKeys) => void;
  filterEmojis: (query: string) => EmojiVirtualScrollData;
}
